<template>
  <el-card>
    <div ref="chartContainer" style="width: 100%; height: 400px;" />
  </el-card>
</template>

<script>
import echarts from 'echarts'

export default {
  name: 'PopUpStat',
  props: {
    typ: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        title: {
          text: ''
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: ['今日:弹框', '今日:下单', '昨日:弹框', '昨日:下单', '上周:弹框', '上周:下单'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: [
          {
            name: '今日:弹框',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '今日:下单',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            },
            lineStyle: {
              type: 'dashed',
              width: 2
            }
          },
          {
            name: '昨日:弹框',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '昨日:下单',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            },
            lineStyle: {
              type: 'dashed',
              width: 2
            }
          },
          {
            name: '上周:弹框',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            }
          },
          {
            name: '上周:下单',
            data: [],
            type: 'line',
            smooth: true,
            label: {
              show: true,
              position: 'top', // 标签显示在折线图顶部
              formatter: '{c}' // 显示数值
            },
            lineStyle: {
              type: 'dashed',
              width: 2
            }
          }
        ]
      }
    },
    refresh(data, typeData) {
      this.option.title.text = this.getTitle(typeData)
      const date = []
      const pay = { today: [], wday: [], yday: [] }
      const pop = { today: [], wday: [], yday: [] }
      for (const i in data) {
        const val = data[i]
        date.push(val.date)
        pop.today.push(val.data.data[this.typ].page_count)
        pop.yday.push(val.y_data[this.typ].page_count)
        pop.wday.push(val.w_data[this.typ].page_count)

        pay.today.push(val.data.data[this.typ].pay_count)
        pay.yday.push(val.y_data[this.typ].pay_count)
        pay.wday.push(val.w_data[this.typ].pay_count)
      }
      this.option.xAxis.data = date
      this.option.series[0].data = pop.today
      this.option.series[1].data = pay.today
      this.option.series[2].data = pop.yday
      this.option.series[3].data = pay.yday
      this.option.series[4].data = pop.wday
      this.option.series[5].data = pay.wday
      this.chart.setOption(this.option, true)
    }, getTitle(typeData) {
      for (const i in typeData) {
        const val = typeData[i]
        if (val.value === this.typ) {
          return val.label
        }
      }
      return '111'
    }
  }
}
</script>

<style scoped>

</style>
